import {useState} from "react";
import Lightbox from "yet-another-react-lightbox";
import {Photo, RowsPhotoAlbum} from "react-photo-album";
// import optional lightbox plugins
import Fullscreen from "yet-another-react-lightbox/plugins/fullscreen";
import Slideshow from "yet-another-react-lightbox/plugins/slideshow";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import {Image} from '@/types';


type ImagesGalleryProps = {
    images: Image[];
    showContactSnippet?: boolean;
}

const ImagesGallery = ({images }: ImagesGalleryProps) => {

    const [index, setIndex] = useState(-1);

    const breakpoints = [1080, 640, 384, 256, 128, 96, 64, 48];


    const photos = images.map(({url, ...rest}) => {

        const width = 1728;
        const height = 1152;

        return {
            src: url,
            width,
            height,
            srcSet: breakpoints.map((breakpoint) => ({
                src: url,
                width: breakpoint,
                height: Math.round((height / width) * breakpoint),
            })),
            ...rest,
        } as Photo;
    })

    return (
        <>
            <RowsPhotoAlbum photos={photos} targetRowHeight={150} onClick={({index}) => setIndex(index)}/>

            <Lightbox
                slides={photos}
                open={index >= 0}
                index={index}
                close={() => setIndex(-1)}
                // enable optional lightbox plugins
                plugins={[Fullscreen, Slideshow, Thumbnails, Zoom]}
            />

        </>
    );
}

export default ImagesGallery;
